<template>
  <div :class="$style.harvestList">
    <div :class="$style.card" :style="{backgroundImage: `url(${item.img})`}" :key="index" v-for="(item, index) in harvestList">
      <div :class="$style.title">{{ item.title }}</div>
      <div :class="$style.btn" @click="jump(item)">点击下载</div>
    </div>
  </div>
</template>

<script>
import { harvestList } from './data'

export default {
  data () {
    return {
      harvestList
    }
  },
  methods: {
    jump (item) {
      window.open(item.link)
    }
  }
}
</script>

<style lang="scss" module>
.harvestList {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 39px;
}

.card {
  position: relative;
  width: 380px;
  height: 210px;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 100%;
}

.title {
  position: absolute;
  top: 44px;
  right: 50px;
  width: 144px;
  font-size: 18px;
  font-weight: 600;
  color: #404040;
  line-height: 25px;
}

.btn {
  position: absolute;
  bottom: 44px;
  right: 76px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 32px;
  background: linear-gradient(90deg, #2E7DFF 0%, #71A7FF 100%);
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  color: #FFFFFF;
  cursor: pointer;

  &:hover {
    background: linear-gradient(90deg, #0362FF 0%, #5394FF 100%);
  }
}
</style>
